<!-- 配件采购历史 -->
<template>
    <div v-loading="loading" >
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">商品：【 {{ apCode }} 】 近 {{purDays}} 天的采购数据</div>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%; margin-bottom: 0px">
                <el-table-column width="180px" prop="OrderCode" label="订单号" show-overflow-tooltip></el-table-column>
                <el-table-column
                    prop="EntpCusName"
                    label="供应商"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column min-width="100px" prop="APCode" label="汽配编码" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="100px" prop="EntpTempGoodsName" label="配件名称" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="100px" prop="AutoSerise" label="适用车型" show-overflow-tooltip></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="Count" label="数量"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="Unit" label="单位"></el-table-column>
                <el-table-column show-overflow-tooltip width="90px" prop="Origin" label="产地"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="Price" label="采购价"></el-table-column>
                <el-table-column show-overflow-tooltip width="110px" prop="SubmitTime" label="采购时间"></el-table-column>
                <el-table-column show-overflow-tooltip width="110px" prop="WarehouseName" label="入库仓库"></el-table-column>
                <el-table-column prop="SName" label="采购员" width="80px" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>
        <div class="dialog-pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['goodsId', 'whId', 'purDays', 'apCode'],
    data() {
        return {
            loading: false,
            searchData: {
                GoodsId: this.goodsId,
                WHId: this.whId,
                PurDays: this.purDays,
                page: 1,
                limit: 10
            },
            tableData: [],
            tableDataLength: 0,
        };
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        getTableData() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpPurchaseOrder/GetPurHisForAutoPur',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
    }
};
</script>
<style lang="less" scoped>
.search-ctn {
    .search-ctn-left {
        margin-top: 5px;
        .search-name,
        .search-item,
        button {
            margin-bottom: 10px;
        }
    }
    .search-btn,
    .search-item {
        margin-bottom: 0;
    }
}
</style>
